import { useContext, useEffect } from 'react';
import UserService from 'services/userService';
import SiteService from 'services/siteService';
import Helpers from 'utils/helpers';
import AuthContext from 'contexts/authContext';
import AppContext from 'contexts/appContext';

export default function LoginViaPortal(props) {
  const { authState, setAuthLoggedIn } = useContext(AuthContext);
  const { setAppLoggedIn } = useContext(AppContext);

  const redirect = () => {
    const redirectPath = props.location.pathname.toLowerCase().replace('/loginviaportal', '');
    const newPath = Helpers.String.isEmpty(redirectPath) ? '/' : redirectPath;
    props.history.push(newPath);
  };

  const redirectToLogin = () => {
    //setTimeout(() => {
    props.history.replace('/Login');
    //}, 2000);
  };

  const executeLogin = () => {
    if (props && props.location && props.location.search && props.location.search.length > 3) {
      const token = (new URLSearchParams(props.location.search)).get('t'); //?t=<token_value>
      if (token && token.length > 0) {
        if (token !== authState.token) {
          UserService.API.getAccountDetails(token).then((account) => {
            SiteService.API.getUserHierarchyTree(token).then((hierarchyData) => {
              setAuthLoggedIn(token, account.user, account.permissions, hierarchyData, 'portal');
              setAppLoggedIn();
              redirect();
            });
          }).catch((error) => {
            console.log('Login Failed...');
            console.log(error);
            redirectToLogin();
          });
        }
        else {
          console.log('Using existing session');
          redirect();
        }
      }
      else {
        console.log('No token supplied');
        redirect();
      }
    }
  };

  useEffect(() => {
    executeLogin();
  });

  return null;
}
